export default __webpack_public_path__ + "static/media/game-start-modal-bg.348d9505.png";